import _Set from "@babel/runtime-corejs3/core-js/set";
import React from "react";
const useSet = setInit => {
  const [currentSet, updateSet] = React.useState(new _Set(setInit));
  const actions = React.useMemo(() => ({
    add: element => {
      updateSet(set => {
        const newSet = new _Set(set);
        newSet.add(element);
        return newSet;
      });
    },
    delete: element => {
      updateSet(set => {
        const newSet = new _Set(set);
        newSet.delete(element);
        return newSet;
      });
    }
  }), []);
  return [currentSet, actions];
};
export default useSet;